// extracted by mini-css-extract-plugin
module.exports = {"hasDatasetsList":"false","mainFontFamily":"\"Open Sans\"","mainFontSize":"13px","font":"13px \"Open Sans\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif"};